
import React, { ChangeEvent, ReactEventHandler, SyntheticEvent, useEffect, useState } from 'react';
import { render } from 'react-dom';
import FormControl from '@mui/material/FormControl';
import { Button, Checkbox, FormControlLabel, FormHelperText, Input, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { pl } from 'date-fns/locale/pl';
import { relative } from 'path';
import { abort } from 'process';

import { LookupCollection, LookupData } from '../../components/grid/GridUtils';
import authService from '../../services/auth/auth.service';
import { CurrentSorter } from 'slickgrid-react';
import CardEditorValidators from './validators';
import planService from '../../services/plan/plan.service';
import standeditorService from '../../services/plan/standeditor.service';
import { AxiosHeaders } from 'axios';
//import { useParams } from 'react-router-dom';
//import { withRouter } from "react-router";


registerLocale('pl', pl)


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface CardEditorParams{
  plan_id:number
}

class InputState{
    helperText: string = ''
    error: boolean = false 
} 

  
export class TechnicalCardData{
    id?: number  
	  row_no?: number
	  name: string =''
    date: number = 0
    plangroup_id? : number
    plangroupname : string = ''
	  size: string = ''
    color_stand: string = ''
    color_wall: string = ''
    openeduser_id? : number
	  openedusername : string = ''
    openeddate: number = 0
    trader_names:  string = ''
    trader_names_array :string[] = []
    created? : Date
    modified? : Date
    width : number = 0
    height : number = 0

	  tc_fairdate : string = ''
    tc_objectname : string = ''
    tc_objectaddress : string = ''
    tc_visitoropeninghours : string = ''
    tc_exhibitoropeninghours : string = ''
    tc_listingdate : string = ''
    tc_checkingdate : string = ''
    tc_constructiondate : string = ''
    tc_componentgraphicsdate :string = ''
    tc_readygraphicsdate : string = ''
    tc_contactperson : string = ''

	  tc_componentpresentationdate : string = ''
    tc_readypresentationdate : string = ''
    tc_insertsdate : string = ''
    tc_disassemblystand : string = ''
    tc_othercomments : string = ''
    note1 : string = ''
    note2 : string = ''
	
	  parkrules : string = ''
    tc_disassemblybuiltstand : string = ''
    tc_parkmapimage : string = ''
    language_id : string = ''
}



export interface CardEditorState{
    input_name_state : InputState; 
    input_date_state : InputState; 
    input_plangroupname_state : InputState; 
	  input_size_state : InputState; 
    input_color_stand_state : InputState; 
    input_color_wall_state : InputState; 
    input_trader_names_state : InputState; 
    input_width_state : InputState; 
    input_height_state : InputState; 
	  input_tc_fairdate_state : InputState; 
    input_tc_objectname_state : InputState; 
    input_tc_objectaddress_state : InputState; 
    input_tc_visitoropeninghours_state : InputState; 
    input_tc_exhibitoropeninghours_state : InputState; 
    input_tc_listingdate_state : InputState; 
    input_tc_checkingdate_state : InputState; 
    input_tc_constructiondate_state : InputState; 
    input_tc_componentgraphicsdate_state : InputState; 
    input_tc_readygraphicsdate_state : InputState; 
	  input_tc_componentpresentationdate_state : InputState; 
    input_tc_readypresentationdate_state : InputState; 
    input_tc_insertsdate_state : InputState; 
    input_tc_disassemblystand_state : InputState; 
    input_tc_othercomments_state : InputState; 
    input_note1_state : InputState; 
    input_note2_state : InputState; 
	  input_parkrules_state : InputState; 
    input_tc_disassemblybuiltstand_state : InputState; 
    input_tc_parkmapimage_state : InputState; 
    input_tc_contactperson_state : InputState;
    
    tc_data : TechnicalCardData;

    parkmapimageFile : Blob | null;
    parkmapimageURL : string;

    alertErrorMsg : string[];
    alertInfo : string;
    alertError : string;
    alertWarning : string;
    lookupData  :LookupCollection[] ;
    data_plangroups : LookupData[];
    languages : LookupData[];
    lang : string;

  }


  async function getBase64(file: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve(reader.result)
      }
      reader.onerror = reject
    })
  }
  
export class CardFormEdit extends React.Component<CardEditorParams, CardEditorState> {
    plan_id :number = -1
    date: Date;
    Validators: CardEditorValidators;
    queryParameters;

    
   
  // This function will be triggered when the file field change
  imageChange = async (e:any) => {
    if (e.target.files && e.target.files.length > 0) {
      var b64 = String(await getBase64(e.target.files[0]))
      this.setState((state: CardEditorState) => ({
        ...state,
        tc_data: {...(state.tc_data), tc_parkmapimage: '/p/' + this.plan_id + '/' + e.target.files[0].name},
        parkmapimageURL: b64,
        alertError: ""
      }))
    }
  };

  removeSelectedImage = () => {
    $('#parkmapimage').val("")
    this.setState((state: CardEditorState) => ({
      ...state,
      tc_data: {...(state.tc_data), tc_parkmapimage: ''},
      alertError: ""
    }))
   
  };

  
  
    getParams(){
      //const params = useParams();

      //const param_id = params.id
      //if (param_id){
     //   var tmp_id = parseInt(param_id)
     //   if (!Number.isNaN(tmp_id)){
    // //     this.plan_id = tmp_id
      //  }
    
     // }

    }
    

   
   
    
  checkItemIsEditable(dataContext: any) {
    var isEditable = false

    return true;
  }


    componentDidMount() {
      //this.props.match.params.id; 
      document.body.classList.add('boverride')
      let tmp:string =  String(localStorage.getItem('plan_edit_language')!=null ?  localStorage.getItem('plan_edit_language') : 'pl');
      //this.geteditorlookups(this.state.lang);
      this.geteditorlookups(tmp);
    }

    getTCDataByID() {
      //alert('FF"')
      //return planService.getTCDataByID(this.plan_id, this.state.lang)
      let tmp:string =  String(localStorage.getItem('plan_edit_language')!=null ?  localStorage.getItem('plan_edit_language') : 'pl');
      return planService.getTCDataByID(this.plan_id, tmp);
    }

    geteditorlookups(lang:string){
      return planService.getplanlookups().then(response => {
           let tmp1 : LookupCollection[] = [];
            if ((response) && (Array.isArray(response.data))){
                tmp1  = response.data
            }

            let data_plangroups : LookupData[] = [];

            let languages : LookupData[] = [];

            tmp1?.forEach((item:LookupCollection) => {
              if (item.name === 'plangroups'){
                data_plangroups = item.data; 
              } 
               if (item.name === 'languages'){
                languages = item.data; 
              } 
            });
            let tmp:string =  String(localStorage.getItem('plan_edit_language')!=null ?  localStorage.getItem('plan_edit_language') : 'pl');
            this.setState((state: CardEditorState) => ({
              ...state,
              lookupData : tmp1,
              data_plangroups : data_plangroups,
              languages : languages,
              lang:tmp
              
            }),  () => {
              let tmp:string =  String(localStorage.getItem('plan_edit_language')!=null ?  localStorage.getItem('plan_edit_language') : 'pl');
              //planService.getTCDataByID(this.plan_id, this.state.lang).then((response: any) => { 
              planService.getTCDataByID(this.plan_id,tmp).then((response: any) => {   
                //console.log('Get data OK')
                var data : TechnicalCardData = response
                //console.log(response)
                if (this.checkItemIsEditable(response)){
                    this.setState((state: CardEditorState) => ({
                      ...state,
                      tc_data : data,
                      alertError: ""
                    }), () => {
                      if (this.state.tc_data.tc_parkmapimage != ''){
                        planService.getImage(this.state.tc_data.tc_parkmapimage).then( response => {
       
                          const encoder = new TextEncoder();
                          var byteArray = encoder.encode(response.data)
                          const charCodes =  response.data;
                          const byteNumbers = new Array(charCodes.length);
                          const url = "data:;base64," + response.data

                          this.setState((state: CardEditorState) => ({
                            ...state,
                            parkmapimageFile : null,
                            parkmapimageURL : url,
                            alertError: ""
                          })) 

                        }

                        ).catch( error => {
                            console.log(error)
                          }
                        )
                      }
                    }
                  ) 
                     
                }else{
                  this.setState((state: CardEditorState) => ({
                  ...state,
                  tc_data : new TechnicalCardData(),
                  alertError: "Nie masz uprawnień do edycji tej karty!"
                  }));
                }
              }).catch(
                  () => {
                    let tmp : LookupCollection[] = [];
                    this.setState((state: CardEditorState) => ({
                        ...state,
                        lookupData : [],
                        tc_data : new TechnicalCardData(),
                        alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                    }
              ));           
            }
        )})
      }).catch(
            () => {
              let tmp : LookupData[] = [];
              this.setState((state: CardEditorState) => ({
                    ...state,
                    alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
              }));
              return tmp;
            }
      )
    }
        
                    
    constructor(public readonly props: CardEditorParams) {
        super(props);
        this.plan_id = this.props.plan_id
        this.Validators = new CardEditorValidators(this)
        this.date = new Date()
        let tmp:string =  String(localStorage.getItem('plan_edit_language')!=null ?  localStorage.getItem('plan_edit_language') : 'pl');
        this.state={

          input_name_state: {helperText: '', error:false},
          input_date_state: {helperText: '', error:false},
          input_plangroupname_state: {helperText: '', error:false},
          input_size_state: {helperText: '', error:false},
          input_color_stand_state: {helperText: '', error:false},
          input_color_wall_state : {helperText: '', error:false},
          input_trader_names_state: {helperText: '', error:false}, 
          input_width_state: {helperText: '', error:false},
          input_height_state : {helperText: '', error:false},
          input_tc_fairdate_state : {helperText: '', error:false},
          input_tc_objectname_state: {helperText: '', error:false},
          input_tc_objectaddress_state : {helperText: '', error:false},
          input_tc_visitoropeninghours_state : {helperText: '', error:false},
          input_tc_exhibitoropeninghours_state : {helperText: '', error:false},
          input_tc_listingdate_state : {helperText: '', error:false},
          input_tc_checkingdate_state : {helperText: '', error:false}, 
          input_tc_constructiondate_state : {helperText: '', error:false},
          input_tc_componentgraphicsdate_state : {helperText: '', error:false}, 
          input_tc_readygraphicsdate_state: {helperText: '', error:false},
          input_tc_componentpresentationdate_state: {helperText: '', error:false},
          input_tc_readypresentationdate_state : {helperText: '', error:false},
          input_tc_insertsdate_state : {helperText: '', error:false},
          input_tc_disassemblystand_state : {helperText: '', error:false},
          input_tc_othercomments_state : {helperText: '', error:false},
          input_note1_state : {helperText: '', error:false},
          input_note2_state : {helperText: '', error:false},
          input_parkrules_state : {helperText: '', error:false},
          input_tc_disassemblybuiltstand_state: {helperText: '', error:false},
          input_tc_parkmapimage_state : {helperText: '', error:false},
          input_tc_contactperson_state : {helperText: '', error:false},

          tc_data:new TechnicalCardData(),

          parkmapimageFile : null,
          parkmapimageURL : "",

          alertInfo:"",
          alertError:"",
          alertWarning:"", 
          alertErrorMsg:[],
          lookupData : [],
          data_plangroups:[],
          languages:[],
          lang:tmp
        }

        this.queryParameters = new URLSearchParams(window.location.search)
    }

   

    onMaxlength100Validator(event: { target: any}) {

    }


    action(snackbarId: SnackbarKey){
      return(
      <>
         <Button  onClick={() => { closeSnackbar(snackbarId) }} variant="contained">Zamknij</Button>
        
      </>
      )
    }
    

    


    render() :React.ReactNode{
      if (this.state.alertErrorMsg.length > 0){
        for (const msg in this.state.alertErrorMsg){
          enqueueSnackbar(this.state.alertErrorMsg[msg], {action: this.action, variant: 'warning', preventDuplicate: true,  autoHideDuration:5000, persist: true})
        }
        this.setState((state: CardEditorState) => ({
          ...state,
          alertErrorMsg: []
        }));
      }

      if (this.state.alertInfo) {
        enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
        this.setState((state: CardEditorState) => ({
          ...state,
          alertInfo: ''
        }));
      }

      if (this.state.alertWarning) {
        enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
        this.setState((state: CardEditorState) => ({
          ...state,
          alertWarning: ''
        }));
      }
      if (this.state.alertError) {
        enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
        this.setState((state: CardEditorState) => ({
          ...state,
          alertError: ''
        }));
      }

      const handleLangChange = (event: { target: any}): void => {
         //alert(event.target.value)
         //this.setState((state: CardEditorState) => ({
       // ...state,
        
      //}))
      localStorage.setItem('plan_edit_language', event.target.value);

      this.setState((state: CardEditorState) => ({
           ...state,
           tc_data : {...(state.tc_data), language_id: event.target.value},
           lang : event.target.value,
           alertError: ""
              
            }),  () => {
              planService.getTCDataByID(this.plan_id, this.state.lang).then((response: any) => { 
                console.log('Get data OK')
                var data : TechnicalCardData = response
                //console.log(response)
                if (this.checkItemIsEditable(response)){
                    this.setState((state: CardEditorState) => ({
                      ...state,
                      tc_data : data,
                      alertError: ""
                    }), () => {
                      if (this.state.tc_data.tc_parkmapimage != ''){
                        planService.getImage(this.state.tc_data.tc_parkmapimage).then( response => {
       
                          const encoder = new TextEncoder();
                          var byteArray = encoder.encode(response.data)
                          const charCodes =  response.data;
                          const byteNumbers = new Array(charCodes.length);
                          const url = "data:;base64," + response.data

                          this.setState((state: CardEditorState) => ({
                            ...state,
                            parkmapimageFile : null,
                            parkmapimageURL : url,
                            alertError: ""
                          })) 

                        }

                        ).catch( error => {
                            console.log(error)
                          }
                        )
                      }
                    }
                  ) 
                     
                }else{
                  this.setState((state: CardEditorState) => ({
                  ...state,
                  tc_data : new TechnicalCardData(),
                  alertError: "Nie masz uprawnień do edycji tej karty!"
                  }));
                }
              }).catch(
                  () => {
                    let tmp : LookupCollection[] = [];
                    this.setState((state: CardEditorState) => ({
                        ...state,
                        lookupData : [],
                        tc_data : new TechnicalCardData(),
                        alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                    }
              ));           
            }
      
        )})
      }
      

        return <>
            <section className="content">
              <div className="container-fluid">
              <div className="cardMenu">
                        <div className='cardLeftSubMenu'> 
                        { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                window.location.href = '/plans'
                              }}
                               >
                               Powrót do listy
                               </button>   
                            }
                        </div>
                        
                        
                        <div className='cardCenterSubMenu'>
  
                        </div><div className='cardRightSubMenu'>

                            <label htmlFor="input-s_language" style={{marginRight:10}}>Język:</label>

                            <Select
                                  onChange={handleLangChange}
                                  value={this.state.lang}
                                  id="input-s_language"
                                  size="small"
                                  error={this.state.input_name_state.error}
                                  style={{marginBottom:20, width:"150px",  marginRight:"5px"}}
                                  
                                >
                                  {this.state.languages.map((data) => (
                                    <MenuItem key={data.label} value={data.value}>                
                                      <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                    </MenuItem>
                                  ))}
                            </Select>

                            

                           { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                planService.editplan(this.state.tc_data).then(
        
                                  () =>  {
                                    console.log('FFFF')
                                    console.log(this.state.tc_data.tc_parkmapimage)
                                    if (this.state.tc_data.tc_parkmapimage){
                                      planService.saveImage(this.plan_id, this.state.tc_data.tc_parkmapimage.substring(this.state.tc_data.tc_parkmapimage.lastIndexOf('/')+1), this.state.parkmapimageURL).then(
                                        (data) => {

                                          this.setState((state: CardEditorState,) => ({
                                            ...state,
                                            alertInfo:  "Poprawnie zapisano dane"
                                          }));
                                        }
                                      ).catch(
                                        (error) => {
                                          console.log(error)
                                        }
                                      )
                                  }else{
                                    this.setState((state: CardEditorState,) => ({
                                      ...state,
                                      alertInfo:  "Poprawnie zapisano dane"
                                    }));
                                  }

                                    
                                   
                                 }
                               ).catch(
                                  (error) => {
                                   try{
                                     console.log(error)
                                     this.setState((state: CardEditorState,) => ({
                                       ...state,
                                       alertError: "Błąd podczas zapisu danych"
                                     }));
                                   }catch{
                         
                                   }
                                 }
                               )
                              }}
                               >
                               Zapisz
                               </button>   
                            }
                            { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                window.location.reload()
                              }}
                               >
                                Anuluj
                               </button>   
                            }
                            
                        </div>
                    </div>
                    
                   



                <div className="row">
                  {/* left column */}
                  <div className="col-md-20">
                    <div className="card card-primary" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">Karta techniczna wystawcy</h3>
                        <div className="card-tools">

                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>

                        
                        </div>
                        
                      </div>
                      <div className="card-body">
                        <div>
                          <div className='inline-form-control' style={{position:"relative",float:'left', width:'20%'}}>
                            
                            <div className="sbs-popup-colors sbs-popup-colors-wall">
                              <p className="group">Wybierz kolor</p>
                              <p className="color" style={{backgroundColor: "#a7a9ab"}}><span>#a7a9ab</span></p>
                              <p className="color" style={{backgroundColor: "#f1f1f2"}}><span>#f1f1f2</span></p>
                              <p className="color" style={{backgroundColor: "#c0c0c0"}}><span>#c0c0c0</span></p>
                              <p className="color" style={{backgroundColor: "#808080"}}><span>#808080</span></p>
                            </div> 
                            <p className="plan_COLOR_WALL form-colors w60" style={{width:'250px', textAlign:'center', backgroundColor: this.state.tc_data.color_wall}} >
                              Kolor ścian
                            </p>
                          </div>
                        
                          <div className='inline-form-control' style={{position:"relative",float:'left', width:'20%'}}>
                            <div className="sbs-popup-colors sbs-popup-colors-stand">
                                <p className="group">Wybierz kolor</p>
                                <p className="color c-f1f1f2" style={{backgroundColor: '#f1f1f2'}}><span>#f1f1f2</span></p>
                                <p className="color c-ec4e4e" style={{backgroundColor: '#ec4e4e'}}><span>#ec4e4e</span></p>
                                <p className="color c-eeaf20" style={{backgroundColor: '#eeaf20'}}><span>#eeaf20</span></p>    
                                <p className="color c-e2471b" style={{backgroundColor: '#e2471b'}}><span>#e2471b</span></p>
                                <p className="color c-b81e04" style={{backgroundColor: '#b81e04'}}><span>#b81e04</span></p>
                                <p className="color c-dc0c35" style={{backgroundColor: '#dc0c35'}}><span>#dc0c35</span></p>
                                <p className="color c-29185e" style={{backgroundColor: '#29185e'}}><span>#29185e</span></p>
                                <p className="color c-cb9c7a" style={{backgroundColor: '#cb9c7a'}}><span>#cb9c7a</span></p>
                                <p className="color c-62bc56" style={{backgroundColor: '#62bc56'}}><span>#62bc56</span></p>    
                                <p className="color c-1b95c8" style={{backgroundColor: '#1b95c8'}}><span>#1b95c8</span></p>
                                <p className="color c-0075a4" style={{backgroundColor: '#0075a4'}}><span>#0075a4</span></p>
                                <p className="color c-707070" style={{backgroundColor: '#707070'}}><span>#707070</span></p>
                                <p className="color c-555555" style={{backgroundColor: '#555555'}}><span>#555555</span></p>
                                <p className="color c-ffffff" style={{backgroundColor: '#ffffff'}}><span>#ffffff</span></p>
                              </div>
                              <p  className="stand_COLOR form-colors w220" style={{width:'250px',  textAlign:'center', backgroundColor: this.state.tc_data.color_stand}} >
                                Kolor wykładzin
                              </p>
                          </div>
                          <TextField
                                label="Szerokość [m] (minimum 16m, maksimum 99m)"
                                id="input-width"
                                placeholder=''
                                disabled
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.width == null || this.state.tc_data.width == undefined ? '' : this.state.tc_data.width}
                                error={this.state.input_width_state.error}
                                helperText={this.state.input_width_state.helperText}
                                //onChange={this.Validators.onNameChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"20%", float:"left", marginRight:"5px"}}
                          />
                          <TextField
                                label="Wysokość [m] (minimum 16m, maksimum 99m)"
                                id="input-height"
                                placeholder=''
                                size="small"
                                disabled
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.height == null || this.state.tc_data.height == undefined ? '' : this.state.tc_data.height}
                                error={this.state.input_height_state.error}
                                helperText={this.state.input_height_state.helperText}
                                //onChange={this.Validators.onNameChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"20%", float:"left", marginRight:"5px"}}
                          />
					                  
                          <div style={{clear:"both"}}></div>
                        </div>
                        <div>  
                            <TextField
                              label="Nazwa"
                              id="input-name"
                              placeholder='Wprowadź nazwę planu'
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              required={true}
                              value={this.state.tc_data.name == null || this.state.tc_data.name == undefined ? '' : this.state.tc_data.name}
                              error={this.state.input_name_state.error}
                              helperText={this.state.input_name_state.helperText}
                              onChange={this.Validators.onNameChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"50%", float:"left", marginRight:"5px"}}
                            />
                            <div style={{marginBottom:20, zIndex:2, position:"relative", float:"left", width:"19%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-contactdate" id="input-contactdate-label">Data targów</label>
                              <DatePicker
                                selected={(this.state.tc_data.date == 0 || this.state.tc_data.date == null) ? null : new Date(this.state.tc_data.date)}
                                onChange={this.Validators.onDatechange.bind(this.Validators)} //only when value has changed
                                locale="pl"
                                dateFormat={"yyyy-MM-dd"}
                                showIcon
                                onChangeRaw={(e)=> {
                                
                                }}
                               
                                id={"input-date"}
                                todayButton="Dzisiaj"
                                autoComplete='off'
                                isClearable={true}
                                placeholderText="Wprowadź datę"
                              />
                        
                            </div>

                            <div style={{position:"relative", float:"left", width:"29%", marginRight:"5px"}}>
                              <FormControl style={{width:"100%"}}>
                                <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-trade_name" id="input-trade_name-label">Branża</label>
                                
                                <Select
                                  onChange={this.Validators.onPlanGroupChange.bind(this.Validators)}
                                  value={(this.state.tc_data.plangroupname == null || this.state.tc_data.plangroupname == undefined) ? '' : this.state.tc_data.plangroupname}
                                  id="input-trade_name"
                                  size="small"
                                  error={this.state.input_name_state.error}
                                  style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                                  
                                >
                                  {this.state.data_plangroups.map((data) => (
                                    <MenuItem key={data.label} value={data.label}>                
                                      <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                    </MenuItem>
                                  ))}
                                  </Select>
                              </FormControl>
                            </div>    
                            <div style={{clear:"both"}}></div>
                          </div>
                        
                          <div>
                            <TextField
                                label="Termin targów"
                                id="input-fairdate"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_fairdate == null || this.state.tc_data.tc_fairdate == undefined ? '' : this.state.tc_data.tc_fairdate}
                                error={this.state.input_tc_fairdate_state.error}
                                helperText={this.state.input_tc_fairdate_state.helperText}
                                onChange={this.Validators.onFairDataChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"32%", float:"left", marginRight:"5px"}}
                            />
                            <TextField
                                label="Nazwa obiektu"
                                
                                id="input-objectname"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_objectname == null || this.state.tc_data.tc_objectname == undefined ? '' : this.state.tc_data.tc_objectname}
                                error={this.state.input_tc_objectname_state.error}
                                helperText={this.state.input_tc_objectname_state.helperText}
                                onChange={this.Validators.onObjectNameChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"32%", float:"left", marginRight:"5px"}}
                            />

                            <TextField
                                label="Adres obiektu"
                                id="input-objectaddress"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_objectaddress == null || this.state.tc_data.tc_objectaddress == undefined ? '' : this.state.tc_data.tc_objectaddress}
                                error={this.state.input_tc_objectaddress_state.error}
                                helperText={this.state.input_tc_objectaddress_state.helperText}
                                onChange={this.Validators.onObjectAddressChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"32%", float:"left", marginRight:"5px"}}
                            />
                            <div style={{clear:"both"}}></div>
                          </div>
                          <div>
                            <TextField
                                label="Godziny otwarcia dla Zwiedzających"
                                id="input-visitoropeninghours"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_visitoropeninghours == null || this.state.tc_data.tc_visitoropeninghours == undefined ? '' : this.state.tc_data.tc_visitoropeninghours}
                                error={this.state.input_tc_visitoropeninghours_state.error}
                                helperText={this.state.input_tc_visitoropeninghours_state.helperText}
                                onChange={this.Validators.onVisitorOpenHoursChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                            />
                            <TextField
                                label="Godziny otwarcia dla Wystawców"
                                id="input-exhibitoropeninghours"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_exhibitoropeninghours == null || this.state.tc_data.tc_exhibitoropeninghours == undefined ? '' : this.state.tc_data.tc_exhibitoropeninghours}
                                error={this.state.input_tc_exhibitoropeninghours_state.error}
                                helperText={this.state.input_tc_exhibitoropeninghours_state.helperText}
                                onChange={this.Validators.onExhibitorOpenHoursChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                            />

                          {  <TextField
                                label="Osoba kontaktowa"
                                id="input-contactperson"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={(this.state.tc_data.tc_contactperson == null || this.state.tc_data.tc_contactperson == undefined) ? '' : this.state.tc_data.tc_contactperson}
                                error={this.state.input_tc_contactperson_state.error}
                                helperText={this.state.input_tc_contactperson_state.helperText}
                                onChange={this.Validators.onContactPersonChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"80%", float:"left", marginRight:"5px"}}
                            />
                          }
                           
                            <div style={{clear:"both"}}></div>
                          </div>
                        </div>
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">1. Wizualizacja i wyposażenie powierzchni: zabudowanej lub niezabudowanej</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                        <div>
                            <TextField
                                label="Data dostarczenia nazw na fryzy i do spisu wystawców"
                                id="input-fairdate"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_listingdate == null || this.state.tc_data.tc_listingdate == undefined ? '' : this.state.tc_data.tc_listingdate}
                                error={this.state.input_tc_listingdate_state.error}
                                helperText={this.state.input_tc_listingdate_state.helperText}
                                onChange={this.Validators.onListingDateChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            />
                            <div style={{clear:"both"}}></div>
                        </div>
                        <div>
                            <TextField
                                multiline 
                                label="Uwaga 1"
                                minRows="5"
                                id="input-note1"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.note1 == null || this.state.tc_data.note1 == undefined ? '' : this.state.tc_data.note1}
                                error={this.state.input_note1_state.error}
                                helperText={this.state.input_note1_state.helperText}
                                onChange={this.Validators.onNote1Change.bind(this.Validators)}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            />

                            <TextField
                                multiline 
                                label="Uwaga 2"
                                minRows="5"
                                id="input-note2"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.note2 == null || this.state.tc_data.note2 == undefined ? '' : this.state.tc_data.note2}
                                error={this.state.input_note2_state.error}
                                helperText={this.state.input_note2_state.helperText}
                                onChange={this.Validators.onNote2Change.bind(this.Validators)}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            />

                            <TextField
                                label="Odbiór stoiska w"
                                id="input-checkingdate"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_checkingdate == null || this.state.tc_data.tc_checkingdate == undefined ? '' : this.state.tc_data.tc_checkingdate}
                                error={this.state.input_tc_checkingdate_state.error}
                                helperText={this.state.input_tc_checkingdate_state.helperText}
                                onChange={this.Validators.onCheckingDateChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                            />
                            <TextField
                                label="Zabudowa powierzchni"
                                id="input-constructiondate"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_constructiondate == null || this.state.tc_data.tc_constructiondate == undefined ? '' : this.state.tc_data.tc_constructiondate}
                                error={this.state.input_tc_constructiondate_state.error}
                                helperText={this.state.input_tc_constructiondate_state.helperText}
                                onChange={this.Validators.onConstructionDateChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                            />
                            <div style={{clear:"both"}}></div>
                        </div>
                      </div>
                    
                         
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">2. Grafika na stoisko</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                          <div>
                            <TextField
                                  label="Data dostarczenia materiałów do składowych"
                                  id="input-componentgraphicsdate"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_componentgraphicsdate == null || this.state.tc_data.tc_componentgraphicsdate == undefined ? '' : this.state.tc_data.tc_componentgraphicsdate}
                                  error={this.state.input_tc_componentgraphicsdate_state.error}
                                  helperText={this.state.input_tc_componentgraphicsdate_state.helperText}
                                  onChange={this.Validators.onComponentgraphicsDateChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                              />
                              <TextField
                                  label="Data dostarczenia gotowych plików produkcyjnych"
                                  id="input-readygraphicsdate"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_readygraphicsdate == null || this.state.tc_data.tc_readygraphicsdate == undefined ? '' : this.state.tc_data.tc_readygraphicsdate}
                                  error={this.state.input_tc_readygraphicsdate_state.error}
                                  helperText={this.state.input_tc_readygraphicsdate_state.helperText}
                                  onChange={this.Validators.onReadygraphicsDateChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                              />
                              <div style={{clear:"both"}}></div>
                          </div>
                      </div>
                         
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">3. Publikacje targowe</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                      <div>
                            <TextField
                                  label="Data dostarczenia składowych do prezentacji"
                                  id="input-componentpresentationdate"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_componentpresentationdate == null || this.state.tc_data.tc_componentpresentationdate == undefined ? '' : this.state.tc_data.tc_componentpresentationdate}
                                  error={this.state.input_tc_componentpresentationdate_state.error}
                                  helperText={this.state.input_tc_componentpresentationdate_state.helperText}
                                  onChange={this.Validators.onComponentpresentationDateChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                              />
                              <TextField
                                  label="Data dostarczenia gotowych reklam"
                                  id="input-readypresentationdate"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_readypresentationdate == null || this.state.tc_data.tc_readypresentationdate == undefined ? '' : this.state.tc_data.tc_readypresentationdate}
                                  error={this.state.input_tc_readypresentationdate_state.error}
                                  helperText={this.state.input_tc_readypresentationdate_state.helperText}
                                  onChange={this.Validators.onReadypresentationDateChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"48%", float:"left", marginRight:"5px"}}
                              />
                              <TextField
                                  label="Data dostarczenia insertów do przewodników"
                                  id="input-insertsdate"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_insertsdate == null || this.state.tc_data.tc_insertsdate == undefined ? '' : this.state.tc_data.tc_insertsdate}
                                  error={this.state.input_tc_insertsdate_state.error}
                                  helperText={this.state.input_tc_insertsdate_state.helperText}
                                  onChange={this.Validators.onInsertDateChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                              />
                              <div style={{clear:"both"}}></div>
                          </div>
                      </div>
                         
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">4. Demontaż stoisk</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                          <div>
                              <TextField
                                  label="Demontaż stoisk niezabudowanych"
                                  id="input-disassemblystand"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_disassemblystand == null || this.state.tc_data.tc_disassemblystand == undefined ? '' : this.state.tc_data.tc_disassemblystand}
                                  error={this.state.input_tc_disassemblystand_state.error}
                                  helperText={this.state.input_tc_disassemblystand_state.helperText}
                                  onChange={this.Validators.onDisassemblystandChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                              />

                              <TextField
                                  label="Demontaż stoisk zabudowanych"
                                  id="input-disassemblybuiltstand"
                                  placeholder=''
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  required={false}
                                  value={this.state.tc_data.tc_disassemblybuiltstand == null || this.state.tc_data.tc_disassemblybuiltstand == undefined ? '' : this.state.tc_data.tc_disassemblybuiltstand}
                                  error={this.state.input_tc_disassemblybuiltstand_state.error}
                                  helperText={this.state.input_tc_disassemblybuiltstand_state.helperText}
                                  onChange={this.Validators.onDisassemblyBuiltstandChange.bind(this.Validators)}
                                  style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                              />
                              <div style={{clear:"both"}}></div>
                          </div>
                      </div>
                         
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">5. Zasady parkowania</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                          <div>
                            <TextField
                                multiline 
                                label="Zasady parkowania"
                                minRows="15"
                                id="input-parkrules"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.parkrules == null || this.state.tc_data.parkrules == undefined ? '' : this.state.tc_data.parkrules}
                                error={this.state.input_parkrules_state.error}
                                helperText={this.state.input_parkrules_state.helperText}
                                onChange={this.Validators.onParkrulesChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            />
                             <div style={{clear:"both"}}></div>
                          </div>
                      </div>
                         
                    </div>  


                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">6. Pozostałe uwagi</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                          <div>
                            <TextField
                                multiline 
                                label="Pozostałe uwagi"
                                minRows="15"
                                id="input-othercomments"
                                placeholder=''
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                required={false}
                                value={this.state.tc_data.tc_othercomments == null || this.state.tc_data.tc_othercomments == undefined ? '' : this.state.tc_data.tc_othercomments}
                                error={this.state.input_parkrules_state.error}
                                helperText={this.state.input_parkrules_state.helperText}
                                onChange={this.Validators.onOtherCommentsChange.bind(this.Validators)}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            />
                             <div style={{clear:"both"}}></div>
                          </div>
                      </div>
                         
                    </div>  

                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">7. PLAN WJAZDU NA PARKING DLA WYSTAWCÓW</h3>
                        <div className="card-tools">
                          <button type="button" className="btn btn-tool" data-card-widget="collapse">
                            <i className="fas fa-minus" />
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                        <input
                          accept="image/*"
                          type="file"
                          id = 'parkmapimage'
                          onChange={this.imageChange}
                        />
                        <div>
                        {this.state.tc_data.tc_parkmapimage && (
                          <div style={{ marginTop: 50, display: "flex", flexDirection: "column"}}>
                            <img
                              
                              src={this.state.parkmapimageURL} //URL.createObjectURL(this.state.parkmapimageFile)}
                              //style={{maxWidth: "100%", maxHeight: 320}}
                              alt={this.state.tc_data.tc_parkmapimage.substring(this.state.tc_data.tc_parkmapimage.lastIndexOf('/')+1)}
                             
                            />
                            <button onClick={this.removeSelectedImage} style={{ cursor: "pointer",padding: 15,background: "red",color: "white",border: "none",}}>
                              Usuń mapę
                            </button>
                          </div>
                        )}
                        </div>
                      </div>
                         
                    </div>  


                  </div>
                 

                  
                </div>
                {/* /.row */}
              </div>{/* /.container-fluid */}
            </section>

        </>;
    }

}

export default CardFormEdit